<template>
    <v-container
        id="tickets-page"
        :class="$vuetify.breakpoint.xs ? 'mobile-view-container' : ''"
        :pa="this.$vuetify.breakpoint.xs"
    >
        <v-row>
            <v-col
                cols="12"
                lg="3"
                md="4"
                sm="12"
            >
                <v-row v-if="!$vuetify.breakpoint.xs">
                    <v-col>
                        <span class="toolbar-title">Clipboard Ticket Routing</span>
                    </v-col>
                </v-row>
                <v-row
                    v-if="$vuetify.breakpoint.xs"
                    class="toolbar-mobile-view"
                >
                    <v-col
                        cols="2"
                        style="text-align: center;"
                    >
                        <v-btn
                            icon
                            class="btn-back"
                            @click="cancel()"
                        >
                            <v-icon class="material-icons-outlined">
                                chevron_left
                            </v-icon>
                        </v-btn>
                    </v-col>
                    <v-col style="text-align: start;">
                        <span class="toolbar-title">Clipboard Ticket Routing</span>
                    </v-col>
                    <v-col
                        cols="2"
                        style="text-align: center;"
                    >
                        <v-icon
                            v-if="viewType === 'table_view'"
                            class="material-icons-outlined"
                            @click="handleSelectView('map_view')"
                        >
                            map
                        </v-icon>
                        <v-icon
                            v-if="viewType === 'map_view'"
                            class="material-icons-outlined"
                            @click="handleSelectView('table_view')"
                        >
                            table_rows
                        </v-icon>
                    </v-col>
                </v-row>
                <v-row
                    v-if="!$vuetify.breakpoint.xs || viewType === 'table_view'"
                    class="justify-center"
                    :class="$vuetify.breakpoint.xs ? 'draggable-mobile-area' : ''"
                >
                    <v-col
                        class="col col-11"
                        :style="{'margin': $vuetify.breakpoint.xs ? '12px 30px' : ''}"
                    >
                        <v-row>
                            <v-card
                                class="mx-auto clipboard_route mt-2"
                                style="height:35vh"
                                :style="{'height': $vuetify.breakpoint.xs ? '40vh' : '37vh'}"
                            >
                                <v-navigation-drawer permanent>
                                    <v-system-bar>
                                        <div class="d-flex align-center justify-space-between w-100p">
                                            <div class="d-flex align-center">
                                                <v-icon
                                                    class="material-icons-outlined"
                                                >
                                                    map
                                                </v-icon>
                                                <h4>Routed</h4>
                                            </div>
                                            <div class="p-0">
                                                <v-checkbox
                                                    v-model="showClipboardRouteDetails"
                                                    label="Show Details"
                                                />
                                            </div>
                                        </div>
                                    </v-system-bar>
                                    <v-divider />
                                    <v-list
                                        nav
                                        dense
                                        class="clipboard_route_body"
                                    >
                                        <v-list-item-group
                                            color="primary"
                                        >
                                            <draggable
                                                :list="routedTicketsList"
                                                :scroll-sensitivity="100"
                                                group="clipboardRouteGroup"
                                                ghost-class="ghost"
                                                :options="{ delay: 300, delayOnTouchOnly: true }"
                                                @change="handelDragItem"
                                            >
                                                <v-list-item
                                                    v-for="(item, i) in routedTicketsList"
                                                    :key="i"
                                                    class="d-flex flex-column"
                                                >
                                                    <div
                                                        class="d-flex"
                                                        style="width: 98%;"
                                                    >
                                                        <v-list-item-icon>
                                                            <DragIcon />
                                                            <v-icon
                                                                class="material-icons-outlined"
                                                                @click="getFullTicketsDetails(item.tid)"
                                                            >
                                                                description
                                                            </v-icon>
                                                        </v-list-item-icon>

                                                        <v-list-item-content class="justify-space-between">
                                                            <v-list-item-title>
                                                                {{ item.ticket }}-{{ item.revision_latest }}
                                                            </v-list-item-title>
                                                            <span class="v-list-item__end">
                                                                <v-chip
                                                                    class="ml-2 text-caption"
                                                                    outlined
                                                                >
                                                                    {{ i + 1 }}
                                                                </v-chip>
                                                                <v-icon
                                                                    v-if="item.selected && !$vuetify.breakpoint.xs"
                                                                    class="material-icons-outlined"
                                                                    @click="handelSelectItem()"
                                                                >mdi-map</v-icon>
                                                                <v-icon
                                                                    v-if="!item.selected && !$vuetify.breakpoint.xs"
                                                                    class="material-icons-outlined"
                                                                    @click="handelSelectItem(item.tid)"
                                                                >map</v-icon>
                                                                <v-icon
                                                                    v-if="item.selected && $vuetify.breakpoint.xs"
                                                                    class="material-icons-outlined"
                                                                    @click="handelSelectMobileItem()"
                                                                >mdi-map</v-icon>
                                                                <v-icon
                                                                    v-if="!item.selected && $vuetify.breakpoint.xs"
                                                                    class="material-icons-outlined"
                                                                    @click="handelSelectMobileItem(item.tid)"
                                                                >map</v-icon>
                                                            </span>
                                                        </v-list-item-content>
                                                    </div>
                                                    <div
                                                        v-if="showClipboardRouteDetails"
                                                        class="w-100p clipboard_route_details"
                                                    >
                                                        <v-divider />
                                                        <ul>
                                                            <li><span>Address : </span>{{ item.address }} {{ item.street }}</li>
                                                            <li><span>Type : </span>{{ item.work_type }}</li>
                                                            <li><span>Company : </span>{{ item.company }}</li>
                                                            <li><span>For : </span>{{ item.donefor }}</li>
                                                        </ul>
                                                    </div>
                                                </v-list-item>
                                            </draggable>
                                        </v-list-item-group>
                                    </v-list>
                                </v-navigation-drawer>
                            </v-card>
                        </v-row>
                        <v-row>
                            <v-card
                                class="mx-auto clipboard_route mt-2"
                                :style="{'height': $vuetify.breakpoint.xs ? '40vh' : '37vh'}"
                            >
                                <v-navigation-drawer permanent>
                                    <v-system-bar>
                                        <v-row>
                                            <v-col class="d-flex align-center">
                                                <v-icon
                                                    class="material-icons-outlined"
                                                >
                                                    map
                                                </v-icon>
                                                <h4>Unrouted</h4>
                                            </v-col>
                                            <v-col class="d-flex align-center">
                                                <v-btn
                                                    v-show="showAutoRoute"
                                                    class="ml-auto"
                                                    @click="autoRoute()"
                                                >
                                                    Auto
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-system-bar>
                                    <v-divider />
                                    <v-list
                                        nav
                                        dense
                                        class="clipboard_route_body"
                                    >
                                        <v-list-item-group
                                            color="primary"
                                        >
                                            <draggable
                                                :list="unRoutedTicketsList"
                                                :scroll-sensitivity="100"
                                                group="clipboardRouteGroup"
                                                ghost-class="ghost"
                                                :options="{ delay: 300, delayOnTouchOnly: true }"
                                            >
                                                <v-list-item
                                                    v-for="(item, i) in unRoutedTicketsList"
                                                    :key="i"
                                                    class="d-flex flex-column"
                                                >
                                                    <div
                                                        class="d-flex"
                                                        style="width: 98%;"
                                                    >
                                                        <v-list-item-icon>
                                                            <DragIcon />
                                                            <v-icon
                                                                class="material-icons-outlined"
                                                                @click="getFullTicketsDetails(item.tid)"
                                                            >
                                                                description
                                                            </v-icon>
                                                        </v-list-item-icon>

                                                        <v-list-item-content class="justify-space-between">
                                                            <v-list-item-title>
                                                                {{ item.ticket }}-{{ item.revision_latest }}
                                                            </v-list-item-title>
                                                            <span class="v-list-item__end">
                                                                <v-icon
                                                                    v-if="item.selected && !$vuetify.breakpoint.xs"
                                                                    class="material-icons-outlined"
                                                                    @click="handelSelectItem()"
                                                                >mdi-map</v-icon>
                                                                <v-icon
                                                                    v-if="!item.selected && !$vuetify.breakpoint.xs"
                                                                    class="material-icons-outlined"
                                                                    @click="handelSelectItem(item.tid)"
                                                                >map</v-icon>
                                                                <v-icon
                                                                    v-if="item.selected && $vuetify.breakpoint.xs"
                                                                    class="material-icons-outlined"
                                                                    @click="handelSelectMobileItem()"
                                                                >mdi-map</v-icon>
                                                                <v-icon
                                                                    v-if="!item.selected && $vuetify.breakpoint.xs"
                                                                    class="material-icons-outlined"
                                                                    @click="handelSelectMobileItem(item.tid)"
                                                                >map</v-icon>
                                                            </span>
                                                        </v-list-item-content>
                                                    </div>
                                                    <div
                                                        v-if="showClipboardRouteDetails"
                                                        class="w-100p clipboard_route_details"
                                                    >
                                                        <v-divider />
                                                        <ul>
                                                            <li><span>Address : </span>{{ item.address }} {{ item.street }}</li>
                                                            <li><span>Type : </span>{{ item.work_type }}</li>
                                                            <li><span>Company : </span>{{ item.company }}</li>
                                                            <li><span>For : </span>{{ item.donefor }}</li>
                                                        </ul>
                                                    </div>
                                                </v-list-item>
                                            </draggable>
                                        </v-list-item-group>
                                    </v-list>
                                </v-navigation-drawer>
                            </v-card>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                v-if="!$vuetify.breakpoint.xs || viewType === 'map_view'"
                cols="12"
                lg="9"
                md="8"
                sm="12"
                :class="$vuetify.breakpoint.xs ? 'draggable-mobile-area' : ''"
            >
                <v-row
                    dense
                >
                    <v-col
                        md="2"
                        sm="3"
                    >
                        <v-select
                            v-model="selectedState"
                            :items="clipboardStates"
                            item-text="state"
                            item-value="state"
                            label="State"
                            hide-details="true"
                            outlined
                            dense
                            :disabled="clipboardStates.length === 1"
                            @change="updateState"
                        />
                    </v-col>
                    <v-col
                        md="5"
                        sm="5"
                    >
                        <v-select
                            v-model="selectedCounty"
                            :items="clipboardCounties[selectedState]"
                            item-text="option"
                            item-value="fips"
                            label="County"
                            hide-details="true"
                            outlined
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <div
                            id="map"
                            ref="map-root"
                            style="height: 75vh; border: 1px solid #ccc; background: white;"
                            :style="{'height': this.$vuetify.breakpoint.xs ? '75vh' : '75vh'}"
                            class="mb-2"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row :class="$vuetify.breakpoint.xs ? 'footer-mobile-button': ''">
            <v-col
                v-show="!$vuetify.breakpoint.xs"
                class="col col-md-9"
            />
            <v-col class="col-12 col-md-3 d-flex justify-end">
                <v-btn
                    style="text-transform: none !important"
                    outlined
                    light
                    @click.once="cancel()"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    class="ml-4"
                    @click.once="save()"
                >
                    Save
                </v-btn>
            </v-col>
        </v-row>
        <v-dialog
            v-model="showTicketDetails"
            content-class="map-ticket-details"
            :fullscreen="this.$vuetify.breakpoint.xsOnly"
            max-width="800px"
        >
            <v-card>
                <v-card-title
                    v-if="selectedTicketDetails"
                    class="text-h5"
                >
                    {{ selectedTicketDetails.Tickets.ticket }} - {{ selectedTicketDetails.Tickets.revision }}
                </v-card-title>
                <v-divider />
                <v-card-text class="map-details-card">
                    <pre
                        v-if="selectedTicketDetails"
                        class="px-5 ticket-details"
                        v-text="selectedTicketDetails.Ticket_Text.ticket_body"
                    />
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        style="text-transform: none !important"
                        outlined
                        light
                        @click="closeDetailsDialog()"
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import DragIcon from '@/components/CustomIcons/DragIcon';
import draggable from 'vuedraggable';
import webtmsBackend from '@/services/webtmsBackend';
import salesman from '@/utils/salesman';
import { guidEqual } from '@/utils/guid.js';

import {Style, Stroke, Fill, Text, Circle, RegularShape} from 'ol/style';

import 'ol/ol.css';
import {Map, View, Overlay, Feature, PluggableMap} from 'ol' ;
import * as coordinate from 'ol/coordinate';
import * as control from 'ol/control';
import * as events from 'ol/events';
import * as extent from 'ol/extent';
import * as format from 'ol/format';
import * as geom from 'ol/geom';
import * as interaction from 'ol/interaction';
import * as layer from 'ol/layer';
import * as proj from 'ol/proj';
import * as render from 'ol/render';
import * as reproj from 'ol/reproj';
import * as source from 'ol/source';
import * as sphere from 'ol/sphere';
import * as style from 'ol/style';
import * as tilegrid from 'ol/tilegrid';
import * as webgl from 'ol/webgl';
import * as turf from '@turf/turf';

import '@/components/Map/QMOL.css';
import Compass from '@/assets/compass-rose.png';
import Logo from '@/components/Map/QMOL_Logo.png';
import QMOL_Data from '@/components/Map/QMOL_Data.js';
import {quickMap} from '@/components/Map/QMOL.js';

export default {
    components: {
        DragIcon,
        draggable
    },
    data: () => ({
        qm: null,
        selectedState: '',
        selectedCounty: {option:'*'},
        features: {},
        image: {},
        selectedTicketDetails: null,
        showTicketDetails: false,
        showClipboardRouteDetails: false,
        routedTicketsList: [],
        unRoutedTicketsList: [],
        viewType: 'table_view',
        firstTime: true,
        showAutoRoute: true,
    }),
    computed: {
        tickets() {
            return this.$store.getters.userClipboard;
        },
        ticketMapTickets() {
            return this.tickets.map(ticket => {
                return {
                    tid: ticket.tid,
                    ticket: ticket.ticket,
                    revision: ticket.revision,
                    member_code: ticket.TR_member_code,
                    priority: ticket.priority,
                    type: ticket.type,
                    county: ticket.county,
                    place: ticket.place,
                    geo_lat: ticket.TS_geo_lat,
                    geo_long:ticket.TS_geo_long,
                    geo_height:ticket.TS_geo_height,
                };
            });
        },
        clipboardStates() {
            let data = this.$store.getters.counties;
            // Find all unique states
            let states = [...new Set(data.map(item => item[2]))];
            return states;
        },
        counties() {
            return this.$store.getters.counties;
        },
        clipboardCounties(){
            let counties = this.clipboardStates.reduce((acc, curr) => {
                acc[curr] = this.counties.filter(countie => countie[2] === curr).map(countie => {
                    return {
                        fips: countie[1],
                        state: countie[2],
                        county: countie[3],
                        option: `${countie[3]}, ${countie[2]} (${countie[1]})`,
                    };
                });
                return acc;
            }, {});
            return counties;
        },
    },
    watch: {
        selectedCounty() {
            let selectedCounty = this.clipboardCounties[this.selectedState].find(item => item.fips === this.selectedCounty);
            if(selectedCounty) {
                this.qm.zoomToCounty(selectedCounty.state,selectedCounty.county);
            }
        },
        selectedState() {
            this.selectedCounty = '';
            if(this.selectedState && this.clipboardCounties[this.selectedState].length === 1) {
                this.selectedCounty = this.clipboardCounties[this.selectedState][0].fips;
            } else {
                this.updateMap();
            }
        },
        ticketMapTickets() {
            this.updateMap();
        },
    },
    mounted() {
        this.initQm();

        if(this.clipboardStates.length >= 1) {
            this.selectedState = this.clipboardStates[0];
            this.selectState(this.selectedState);
        }
        if(this.selectedState && this.clipboardCounties[this.selectedState].length === 1) {
            this.selectedCounty = this.clipboardCounties[this.selectedState][0].fips;
        }
        if(this.tickets) {
            this.routedTicketsList = [...this.tickets];

            let index = 1;
            for (const routedTicket of this.routedTicketsList) {
                routedTicket.newIndex = index++;
            }

            if (this.routedTicketsList.length <= 100) {
                this.showAutoRoute = true;
            } else {
                this.showAutoRoute = false;
            }
        }
        this.handelSelectItem();
    },
    methods: {
        initQm(){
            setTimeout(() => {
                try {
                    this.qm = new quickMap(
                        {
                            ol: {View,Map,Overlay,Feature,PluggableMap,control,coordinate,events,extent,format,geom,interaction,layer,proj,render,reproj,source,sphere,style,tilegrid,webgl},
                            turf: turf,
                            target: 'map',
                            compass: Compass,
                            logo: Logo,
                            extraData: QMOL_Data.QMOL_Data,
                        }
                    );

                    this.qm.showDraw=false;
                    this.qm.showEdit=false;
                    this.qm.showDelete=false;
                    this.qm.showMeasure=false;
                    this.qm.showBullseye=false;
                    this.qm.showClear=false;
                    this.qm.showIdentify=false;

                    document.addEventListener('qmolSingleClick', (e)=> {
                        this.singleClick(e);
                    });
                } catch (error) {
                    console.log(error);
                }
            }, 0);
        },
        selectState(state) {
            for(let ticket of this.tickets) {
                if(this.clipboardStates.includes(ticket.state)) {
                    this.updateState(ticket.state);
                } else {
                    this.updateState(state);
                }
            }
            if(!this.tickets.length) {
                this.updateState(state);
            }
        },
        async updateState(state) {
            this.selectedState = state;
            if (state) {
                setTimeout(() => {
                    try {
                        this.qm.zoomToState(this.selectedState);
                    } catch (error) {
                        console.log(error);
                    }
                }, 0);
            }
            await this.updateMap();
        },
        getCountyName(ticketCounty) {
            return this.counties.find(county => {
                return county[3].toUpperCase() === ticketCounty;
            });
        },
        singleClick(event) {
            if (event.detail.features) {
                const features=event.detail.features.features;
                try {
                    let hasUnroutedTicket = this.unRoutedTicketsList.find((ticket) => guidEqual(ticket.tid, features[0].properties.ticket.tid));
                    if(hasUnroutedTicket) {
                        for (const ticket of this.unRoutedTicketsList) {
                            if(guidEqual(ticket.tid, features[0].properties.ticket.tid)) {
                                this.routedTicketsList.push(ticket);
                            }
                        }
                        this.routedTicketsList = this.routedTicketsList.map((item, index) => {
                            item.newIndex = index + 1;
                            return item;
                        });
                        this.unRoutedTicketsList = this.unRoutedTicketsList.filter((ticket) => !guidEqual(ticket.tid, features[0].properties.ticket.tid));
                        this.updateMap();
                        return;
                    }

                    let hasRoutedTicket = this.routedTicketsList.find((ticket) => guidEqual(ticket.tid, features[0].properties.ticket.tid));
                    if(hasRoutedTicket) {
                        for (const ticket of this.routedTicketsList) {
                            if(guidEqual(ticket.tid, features[0].properties.ticket.tid)) {
                                this.unRoutedTicketsList.push(ticket);
                            }
                        }
                        this.unRoutedTicketsList = this.unRoutedTicketsList.map((item) => {
                            item.newIndex = 0;
                            return item;
                        });
                        this.routedTicketsList = this.routedTicketsList.filter((ticket) => !guidEqual(ticket.tid, features[0].properties.ticket.tid));

                        let index = 1;
                        for (const routedTicket of this.routedTicketsList) {
                            routedTicket.newIndex = index++;
                        }
                        this.updateMap();
                        return;
                    }
                } catch (error) {
                    console.log('no ticket');
                }
            }
        },
        clear() {
            this.unRoutedTicketsList = this.unRoutedTicketsList.concat(this.routedTicketsList);
            this.routedTicketsList = [];
        },
        async getFullTicketsDetails(tid) {
            this.selectedTicketDetails = await webtmsBackend.getFullTickets(tid);
            this.showTicketDetails = true;
        },
        closeDetailsDialog() {
            this.selectedTicketDetails = null;
            this.showTicketDetails = false;
        },
        async updateMap(tid) {
            let ticketShape;
            if(tid) {
                ticketShape = await webtmsBackend.getFullTickets(tid);
            }
            const tickets = {
                type: 'FeatureCollection',
                features: [],
            };

            let singleTicketZoom = [];

            for (const ticket of this.ticketMapTickets){
                const fillColor=this.hexToRGBA(this.priorityIconColor(ticket.priority),0.8);
                const fillColor2=this.hexToRGBA(this.priorityIconColor(ticket.priority),0.2);
                let route = this.routedTicketsList.find(item => guidEqual(item.tid, ticket.tid));
                let image, image2;
                switch (this.priorityShape(ticket.priority)) {
                    case 'circle':
                        image=new Circle({stroke:new Stroke({color:'black',width:2}),fill:new Fill({color:fillColor}),radius:route?10:10});
                        break;
                    case 'square':
                        image=new RegularShape({stroke:new Stroke({color:'black',width:2}),fill:new Fill({color:fillColor}),points:4,radius:10,angle:Math.PI/4});
                        break;
                    case 'triangle':
                        image=new RegularShape({stroke:new Stroke({color:'black',width:2}),fill:new Fill({color:fillColor2}),points:3,radius:10});
                        image2=new RegularShape({stroke:new Stroke({color:'black',width:2}),fill:new Fill({color:fillColor}),points:3,radius:10});
                        break;
                }
                if(tid && guidEqual(tid, ticket.tid)) {
                    const strokeColor = this.hexToRGBA('#8a83c1',1);
                    const fillColor = this.hexToRGBA('#8a83c1',0.2);
                    for (const shape of ticketShape?.Ticket_Polygons){
                        tickets.features.push({
                            type: 'Feature',
                            properties: {
                                show: true,
                                style: function(zoom){
                                    return zoom<0?undefined:new Style({
                                        text:new Text({text:zoom<12?'': zoom<15?ticket.ticket:`${ticket.ticket}-${ticket.revision}\n${ticket.type}`,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:zoom<15?-15:-25}),
                                        stroke:new Stroke({color:strokeColor,width:2}),
                                        fill:new Fill({color:fillColor}),
                                    });
                                },
                            },
                            geometry: {
                                type: 'Polygon',
                                coordinates: JSON.parse(`[[[${shape?.shapestring.replace(/,-/g,'],[-')}]]]`)
                            },
                        }, {
                            type: 'Feature',
                            properties: {
                                style: function(zoom){
                                    return zoom<0?undefined:new Style({
                                        // text:new Text({text:zoom<12?'': zoom<15?ticket.ticket:`${ticket.ticket}-${ticket.revision}\n${ticket.type}`,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:zoom<15?-15:-25}),
                                        image: image,
                                        text:new Text({text: route ? `${route.newIndex}` : '',font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:0}),fill:new Fill({color:'black'}),offsetY:0,offsetX:1}),
                                    });
                                },
                                ticket: ticket,
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [ticket.geo_long, ticket.geo_lat]
                            }
                        });
                        singleTicketZoom.push(tickets.features[tickets.features.length-1]);
                        singleTicketZoom.push(tickets.features[tickets.features.length-2]);
                    }
                } else {
                    tickets.features.push({
                        type: 'Feature',
                        properties: {
                            style: function(zoom){
                                return zoom<0?undefined:new Style({
                                    image: image,
                                    // text:new Text({text:zoom<0?'': zoom<15?ticket.ticket:`${ticket.ticket}-${ticket.revision}\n${ticket.type}`,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:zoom<15?-15:-25}),
                                    // text:new Text({text: route ? `${route.newIndex}` : '',font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:0}),fill:new Fill({color:'black'}),offsetY:0,offsetX:1}),
                                    text:new Text({text: route ? `${route.newIndex}` : `${ticket.ticket}`,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:0}),fill:new Fill({color:'black'}),offsetY:route?0:-15,offsetX:1}),
                                });
                            },
                            ticket: ticket,
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: [ticket.geo_long, ticket.geo_lat]
                        }
                    });

                    if (ticket.priority==='EMER'){
                        tickets.features.push({
                            type: 'Feature',
                            properties: {
                                style: function(zoom){
                                    return zoom<0?undefined:new Style({
                                        image: image2
                                    });
                                },
                                ticket: ticket,
                                blink: true,
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [ticket.geo_long, ticket.geo_lat]
                            }
                        });
                    }
                }
            }

            if (this.routedTicketsList.length>1){
                for (var i = 0; i < this.routedTicketsList.length-1; i++) {
                    tickets.features.push(
                        {type: 'Feature',
                            properties: {
                                style: new Style( {stroke:new Stroke({color:this.hexToRGBA('#FFFFFF',1),width:4})})
                            },
                            geometry: {
                                type: 'LineString',
                                coordinates: [
                                    [this.routedTicketsList[i].TS_geo_long, this.routedTicketsList[i].TS_geo_lat],
                                    [this.routedTicketsList[i+1].TS_geo_long, this.routedTicketsList[i+1].TS_geo_lat]
                                ]
                            }
                        },
                        {type: 'Feature',
                            properties: {
                                style: new Style( {stroke:new Stroke({color:this.hexToRGBA('#000000',1),width:3})})
                            },
                            geometry: {
                                type: 'LineString',
                                coordinates: [
                                    [this.routedTicketsList[i].TS_geo_long, this.routedTicketsList[i].TS_geo_lat],
                                    [this.routedTicketsList[i+1].TS_geo_long, this.routedTicketsList[i+1].TS_geo_lat]
                                ]
                            }
                        },
                    );
                }
            }

            setTimeout(() => {
                try {
                    this.qm.clearShow();
                    this.qm.addToShow(tickets);

                    if (singleTicketZoom.length>0 ){
                        this.qm.zoomToFeatures({
                            type: 'FeatureCollection',
                            features: singleTicketZoom});
                    } else if(this.firstTime){
                        this.qm.zoomToFeatures(tickets);
                        this.firstTime = false;
                    }
                } catch (error) {
                    console.log(error);
                }

            }, 0);
        },
        async save() {
            let routedIds = this.routedTicketsList.map(item => item.TR_rowid);
            let unRoutedIds = this.unRoutedTicketsList.map(item => item.TR_rowid);
            routedIds = routedIds.concat(unRoutedIds);
            let clipboardRoute = await webtmsBackend.updateClipboardItem('set', routedIds);
            if(clipboardRoute.status === 'OK') {
                this.$store.commit('SET_USER_CLIPBOARD', clipboardRoute.data);
                this.$router.push({ path: '/tickets' });
            }
        },
        cancel() {
            this.$router.push({ path: '/tickets' });
        },
        hexToRGBA (hex, alpha) {
            return `${hex}${Math.floor(alpha * 255).toString(16).padStart(2, 0)}`;
        },
        priorityIconColor(priority) {
            switch(priority) {
                case 'NORM': case 'ROUT':
                    return '#90EE90';
                case 'RUSH': case 'SHRT': case 'INSF':
                    return '#FFA500';
                case 'EMER':
                    return '#FF0000';
                case 'NONC':
                    return '#ADD8E6';
                default:
                    return '#FFFFFF';
            }
        },
        priorityShape(priority) {
            switch(priority) {
                case 'NORM': case 'ROUT':
                    return 'circle';
                case 'RUSH': case 'SHRT': case 'INSF': case 'NONC':
                    return 'square';
                case 'EMER':
                    return 'triangle';
                default:
                    return 'circle';
            }
        },
        priorityIcon(priority) {
            switch(priority) {
                case 'NORM': case 'ROUT':
                    // gray circle exclamation
                    return 'error';
                case 'RUSH': case 'SHRT': case 'INSF':
                    // yellow circle exclamation
                    return 'error';
                case 'EMER':
                    // red bell exclamation
                    return 'notification_important';
                case 'NONC':
                    // light blue circle exclamation
                    return 'error';
                default:
                    return '';
            }
        },
        handelSelectItem(tid) {
            let routedCount = 0;
            let unRoutedCount = 0;
            this.routedTicketsList = this.routedTicketsList.map((item) => {
                if(guidEqual(item.tid, tid)) {
                    item.selected = true;
                } else {
                    item.selected = false;
                    routedCount++;
                }
                return item;
            });
            this.unRoutedTicketsList = this.unRoutedTicketsList.map((item) => {
                if(guidEqual(item.tid, tid)) {
                    item.selected = true;
                } else {
                    item.selected = false;
                    unRoutedCount++;
                }
                return item;
            });

            if(unRoutedCount !== this.unRoutedTicketsList.length || routedCount !== this.routedTicketsList.length) {
                this.updateMap(tid);
            } else {
                this.updateMap();
            }
        },
        handelSelectMobileItem(tid) {
            this.handelSelectItem(tid);
            setTimeout(() => {
                this.viewType = 'map_view';
            }, 0);
        },
        handelDragItem() {
            this.routedTicketsList = this.routedTicketsList.map((item, index) => {
                item.newIndex = index + 1;
                return item;
            });
            this.handelSelectItem();
        },
        handleSelectView(view) {
            this.viewType = view;
            if(view === 'map_view') {
                if (this.qm === null){
                    this.initQm();
                }
                setTimeout(() => {
                    this.updateMap();
                },0);
            }
        },
        async autoRoute(){
            if (this.routedTicketsList.length > 0 && this.unRoutedTicketsList.length === 0){
                for (const ticket of this.routedTicketsList) {
                    ticket.newIndex = 0;
                    ticket.selected = false;
                    this.unRoutedTicketsList.push(ticket);
                }
                this.routedTicketsList = [];
                this.updateMap();
                return;
            }

            if (this.routedTicketsList.length > 0 && this.unRoutedTicketsList.length > 0) {
                for (const ticket of this.unRoutedTicketsList) {
                    this.routedTicketsList.push(ticket);
                }
                this.unRoutedTicketsList=[];
                for (const ticket of this.routedTicketsList) {
                    ticket.newIndex = 0;
                    ticket.selected = false;
                    this.unRoutedTicketsList.push(ticket);
                }
                this.routedTicketsList=[];
            }

            let points=[];
            for (const ticket of this.unRoutedTicketsList){
                points.push(new salesman.Point(ticket.TS_geo_long, ticket.TS_geo_lat));
            }

            let solution = salesman.solve(points);
            let ordered_points = solution.map(i => points[i]);

            let newIndex = 1;
            for (const ticket of this.routedTicketsList){
                newIndex=ticket.newIndex;
            }

            for (const point of ordered_points) {
                for (const ticket of this.unRoutedTicketsList){
                    if(ticket.TS_geo_long === point.x && ticket.TS_geo_lat === point.y) {
                        let found = false;
                        for (const routed of this.routedTicketsList){
                            if(guidEqual(routed.TR_rowid, ticket.TR_rowid)) {
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            ticket.newIndex = newIndex++;
                            ticket.selected = false;
                            this.routedTicketsList.push(ticket);
                        }
                    }
                }
            }

            this.unRoutedTicketsList = [];
            this.updateMap();
        }
    },
};
</script>
<style>
.state-select {
    border: 1px solid #ccc;
    border-radius:4px;
    margin: 2px 12px;
    position: relative;
}
.state-select select {
    width: 60px;
    padding: 4px 8px;
}
.state-select .state-select-icon {
    position: absolute;
    right: 0px;
    pointer-events: none;
    padding: 4px 0px;
}
.clipboard_route {
    box-sizing: border-box;
    height: 275px;
    border-radius: 4px;
    width: 100%;
}
.clipboard_route aside {
    transform: translateX(0%) !important;
}
.clipboard_route .v-navigation-drawer--close {
    visibility: unset !important;
}
.clipboard_route .v-navigation-drawer {
    width: 100% !important;
}
.clipboard_route .v-navigation-drawer .v-navigation-drawer__content {
    overflow: hidden;
}
.clipboard_route .v-navigation-drawer .v-navigation-drawer__content .v-icon {
    font-size: 1.2rem;
    color: #7F8592;
}
.clipboard_route .v-navigation-drawer .v-navigation-drawer__content h4 {
    font-weight: 500;
    color: #35383F;
}
.clipboard_route .v-navigation-drawer .v-navigation-drawer__content .v-input--checkbox label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.0025em;
    color: #35383F;
}
.clipboard_route .v-navigation-drawer .v-navigation-drawer__content .v-system-bar {
    height: 44px !important;
    background: #F2F6FC;
    border: 1px solid #D5D8DE;
    border-radius: 4px 4px 0px 0px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;
}
.clipboard_route_body .v-list-item {
    background: #F5F7FA;
}
.clipboard_route_body .v-list-item::after {
    min-height: unset;
}
.clipboard_route_body .v-list-item .v-list-item__icon {
    margin-right: 8px !important;
}
.clipboard_route_body .v-list-item__content .v-list-item__title,
.clipboard_route_body .v-list-item__content .v-list-item__end {
    flex: unset;
}
.clipboard_route_body {
    height: 230px;
    overflow-y: auto;
    margin-top: 42px;
}
.clipboard_route_body .v-list-item__content .v-list-item__end .v-chip {
    height: 20px;
    width: 20px;
    padding: 0;
    padding-left: 6px;
    margin-right: 5px;
}
.clipboard_route_details ul {
    list-style: none;
    padding: 6px;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.004em;
    color: #35383F;
}
.clipboard_route_details ul span {
    font-weight: 400;
}
.clipboard_route_body .v-item-group div {
    height: 214px;
}
.clipboard_route_body .v-item-group div div {
    max-height: unset;
    height: unset;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.map-ticket-details.v-dialog {
    overflow: hidden !important;
}
.map-ticket-details .map-details-card {
    overflow-y: auto;
    max-height: 550px;
}
.map-ticket-details .ticket-details {
    white-space: pre-wrap;
    font-family: courier;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.004em;
    color: #35383F;
    margin: 16px 0px;
}

.toolbar-mobile-view {
    align-items: center;
    border-bottom: 1px solid #d5d8de;
    box-shadow: 0px 0px 10px 0px #d5d8de;
    position: fixed;
    left: 0;
    right: 0;
    z-index: 9;
    background: white;
    margin-bottom: 15px;
}
.draggable-mobile-area {
    margin-top: 40px !important;
    height: calc(100vh - 95px);
    overflow-y: auto;
    overflow-x: hidden;
}
.footer-mobile-button {
    align-items: center;
    border-top: 1px solid #d5d8de;
    box-shadow: 0px -5px 10px 0px #d5d8de;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 5px;
    z-index: 9;
    background: white;
    padding: 0px 16px;
}
.footer-mobile-button .v-btn:not(.v-btn--round).v-size--default {
    width: 47%;
}

</style>